import React from 'react';
import { titleize } from 'underscore.string';
import { Glyphicon } from 'react-bootstrap';
import formatMoney from 'utils/formatters/Money';

const defaultFormatter = (cell) => <span>{titleize(cell)}</span>;

const booleanFormatter = (cell, row) => (
  <span>{row.processed ? 'Yes' : 'No'}</span>
);

const editFormatter = (cell, row) => {
  const editClass = { marginLeft: '6px' };
  if (!row.editClick) {
    return null;
  }
  return (
    <button
      type="button"
      onClick={row.editClick}
      className="text-grey-darker"
      style={editClass}
    >
      <Glyphicon glyph="edit" />
    </button>
  );
};

const equipmentFormatter = (cell, row) => {
  return <a onClick={row.viewClick}>{cell}</a>;
};

const reverseFormatter = (cell, row) => {
  const removeClass = {
    pointerEvents: 'all',
    cursor: 'pointer',
    color: '#8795a1',
    fontWeight: 700,
    textAlign: 'center',
    marginLeft: '18px',
  };
  if (!row.reverseClick) {
    return null;
  }
  return (
    <span onClick={row.reverseClick} style={removeClass}>
      X
    </span>
  );
};

const shipmentFormatter = (cell, row) => {
  return (
    <a href={`/shipments/${row.job_id}`} target="_blank">
      {cell}
    </a>
  );
};

const priceFormatter = (cell, row) => {
  const grayClass = {
    color: '#8795a1',
  };
  return <span style={grayClass}>{formatMoney(cell, row?.currency)}</span>;
};

const boldPriceFormatter = (cell, row) => {
  const boldClass = {
    fontWeight: 700,
  };
  return <span style={boldClass}>{formatMoney(cell, row?.currency)}</span>;
};

function determinePriceFormatter(cell, row, type) {
  if (row.ledger) {
    switch (row.ledger) {
      case 'payables':
        return type === 'shipper'
          ? boldPriceFormatter(cell, row)
          : priceFormatter(cell, row);
      case 'receivables':
        return type === 'carrier'
          ? boldPriceFormatter(cell, row)
          : priceFormatter(cell, row);
      default:
        break;
    }
  }
  return priceFormatter(cell, row);
}

const columns = [
  {
    dataField: 'shipment_id',
    text: 'Shipment',
    localizationSlug: 'SHIPMENT',
    count: 1,
    sort: true,
    formatter: shipmentFormatter,
  },
  {
    dataField: 'equipment.equipment_id',
    text: 'Equipment',
    localizationSlug: 'EQUIPMENT',
    sort: true,
    formatter: equipmentFormatter,
  },
  {
    dataField: 'message',
    text: 'Name (Description)',
    localizationSlug: 'NAME_DESCRIPTION',
    sort: true,
    formatter: defaultFormatter,
  },
  {
    dataField: 'processed',
    text: 'Processed',
    localizationSlug: 'PROCESSED',
    sort: false,
    formatter: booleanFormatter,
  },
  {
    dataField: 'shipper_rate',
    text: 'Shipper Rate',
    localizationSlug: 'SHIPPER_RATE',
    sort: false,
    formatter: (cell, row) => determinePriceFormatter(cell, row, 'shipper'),
  },
  {
    dataField: 'carrier_cost',
    text: 'Carrier Cost',
    localizationSlug: 'CARRIER_COST',
    sort: false,
    formatter: (cell, row) => determinePriceFormatter(cell, row, 'carrier'),
  },
  {
    dataField: 'reverse',
    text: 'Reverse',
    localizationSlug: 'REVERSE',
    sort: false,
    formatter: reverseFormatter,
  },
  {
    dataField: 'edit',
    text: 'Edit',
    localizationSlug: 'EDIT',
    sort: false,
    formatter: editFormatter,
  },
];

export default {
  columns,
};
